export default function (state = {
    calendar: { search_string: '', list: {}, details: {}, validation: {}, options: {}, filter_user_id: null, users_list: [] }
}, action) {
    switch (action.type) {
        case 'CALENDAR_UPDATE_SEARCH_STRING':
            state.calendar.search_string = action.value;
            return { ...state };
        case 'CALENDAR_SEARCH':
            state.calendar.list = action.data.list;
            return { ...state };
        case 'CALENDAR_BY_MONTH':
            state.calendar.list = action.data.list;
            return { ...state };
        case 'CALENDAR_OPTIONS':
            state.calendar.options = action.data.options;
            return { ...state };
        case 'CALENDAR_DETAILS':
            state.calendar.details = action.data.record;
            return { ...state };
        case 'CALENDAR_UPDATE_FORM':
            state.calendar.details[action.field] = action.value;
            if (state.calendar.validation[action.field]) {
                state.calendar.validation[action.field] = {};
            }
            return { ...state };
        case 'CALENDAR_VALIDATION_ERROR':
            state.calendar.validation = action.data;
            return { ...state };
        case 'CALENDAR_SELECTED':
            state.calendar.selected = action.value;
            state.calendar.details = {};
            state.calendar.validation = {};
            return { ...state };
        case 'CALENDAR_DESELECTED':
        case 'CALENDAR_UPDATED':
        case 'CALENDAR_INSERTED':
        case 'CALENDAR_DELETED':
            state.calendar.selected = null;
            state.calendar.details = {};
            state.calendar.validation = {};
            return { ...state };
        case 'CALENDAR_CANCEL_SELECT':
            state.calendar.selected = null;
            return { ...state };
        case 'CALENDAR_USERS_LIST':
            state.calendar.users_list = action.data.users || [];
            return { ...state };
        case 'CALENDAR_SET_USER_FILTER':
            state.calendar.filter_user_id = action.value;
            return { ...state };
        case 'CALENDAR_SET_FILTER':
            state.calendar.filter = action.filter;
            return { ...state };
        case 'CALENDAR_INSERT_ERROR':
        case 'CALENDAR_UPDATE_ERROR':
            return { ...state };
        default:
            break;
    }
    return state;
}
